import React from 'react'
import PropTypes from 'prop-types'
import { MediaPlayer } from 'components/UIElements'
import { formatAndSanitizeHTML } from 'utils/misc'
import SurveyQuestion from '../SurveyQuestion'
import QuestionTitleImage from '../QuestionTitleImage'
import MakeScrollable from '../MakeScrollable'
import QuestionFooter from '../QuestionFooter'
import {
  checkLogicAndComplete,
  getShouldRenderNextQuestion,
} from '../../utils/instrumentUtils'

const completeTextPromptQuestion = (props) => {
  const {
    question,
    id,
    completeQuestion,
    nextQ,
    webSurvey,
    submissionSurvey,
    nextQId,
    reviewFunctionalitySupported,
    isConsent = false,
    isLastQuestion = false,
    isSibling = false,
  } = props
  const { label, type, attributes } = question
  const { required } = attributes
  const submission = {
    id,
    label,
    name: id,
    type,
    required,
    state: 'ANSWERED',
    answer: [],
  }
  const currentAnswer = { [id]: [] }

  const shouldRenderNextQ = getShouldRenderNextQuestion({
    isConsent,
    isLastQuestion,
    isSibling,
  })

  checkLogicAndComplete(
    webSurvey,
    id,
    submissionSurvey,
    currentAnswer,
    nextQId,
    nextQ,
    completeQuestion,
    submission,
    reviewFunctionalitySupported,
    shouldRenderNextQ,
  )
}

function TextPrompt(props) {
  const {
    className,
    id,
    isConsent,
    isLastQuestion,
    question,
    renderBackButton,
    strings,
    forwardedRef,
    submissionLoading,
    submissionSurvey,
    webSurvey,
    isSibling = false,
  } = props
  const _className = className ? ` ${className}` : ''
  const { label, imageSrc, mediaSrc } = question
  return (
    <SurveyQuestion id={id}>
      <MakeScrollable>
        <div className={`survey-question text${_className}`} ref={forwardedRef}>
          <MakeScrollable>
            <p className='question-label'>
              <span
                className='text-prompt'
                dangerouslySetInnerHTML={{
                  __html: formatAndSanitizeHTML(label),
                }}
              />
              <QuestionTitleImage imageSrc={imageSrc} questionId={id} />
              {mediaSrc && (
                <MediaPlayer
                  url={mediaSrc}
                  fallbackMessage={strings.media_fallbackMessage}
                />
              )}
            </p>
            {!isSibling && (
              <QuestionFooter
                completed
                id={id}
                isConsent={isConsent}
                isLastQuestion={isLastQuestion}
                loading={submissionLoading}
                onComplete={() => completeTextPromptQuestion(props)}
                question={question}
                renderBackButton={renderBackButton}
                strings={strings}
                submissionSurvey={submissionSurvey}
                webSurvey={webSurvey}
              />
            )}
          </MakeScrollable>
        </div>
      </MakeScrollable>
    </SurveyQuestion>
  )
}

const ForwardedTextPrompt = React.forwardRef((props, ref) => (
  <TextPrompt {...props} forwardedRef={ref} />
))

export default ForwardedTextPrompt

TextPrompt.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  question: PropTypes.object,
  renderBackButton: PropTypes.func,
  strings: PropTypes.objectOf(PropTypes.string),
  imageSrc: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
}
